import { useState, useEffect } from 'react'
import { getAllThemes, applyTheme, getThemeFromUserSettings } from '../utils/themeManager'
import { useAuth } from '../contexts/AuthContext'

export const useThemeSelector = () => {
  const { user, isAuthenticated, getCurrentUser } = useAuth()
  const [currentTheme, setCurrentTheme] = useState(getThemeFromUserSettings(user?.userSettings))
  const [isOpen, setIsOpen] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const themes = getAllThemes()

  useEffect(() => {
    if (user?.userSettings) {
      const userTheme = getThemeFromUserSettings(user.userSettings)
      setCurrentTheme(userTheme)
    }
  }, [user])

  const handleThemeChange = async (themeClass) => {
    setIsUpdating(true)
    try {
      await applyTheme(themeClass, isAuthenticated, isAuthenticated ? getCurrentUser : null)
      setCurrentTheme(themeClass)
      setIsOpen(false)
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Failed to update theme:', error)
    } finally {
      setIsUpdating(false)
    }
  }

  const toggleOpen = () => setIsOpen(!isOpen)

  return {
    currentTheme,
    isOpen,
    isUpdating,
    themes,
    handleThemeChange,
    toggleOpen
  }
}